import { Box, Button, useTheme } from '@mui/material';
import { ProjectWorkPackage } from './ProjectWorkPackage';
import CardGrid from '../../../cards/layout/CardGrid';
import { tokens } from '../../../../global/theme/tokens';
import { ProjectAddElementButton } from '../ProjectAddElementButton';
import { WorkPackageForm } from './WorkPackageForm';
import { updateOrCreate } from '../../../special/updateOrCreate';
import { useEffect, useState } from 'react';
import moment from 'moment';

const ProjectWorkPackageStack = ({
  phase,
  onPhaseChange,
  editmode,
  project,
  allowedStatuses,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  const [workPackages, setWorkPackages] = useState([]);

  function handleChange(data) {
    onPhaseChange({
      ...phase,
      workPackages: updateOrCreate(phase.workPackages, data, true),
    });
  }

  function handleDelete(itemToDelete) {
    const newWorkPackages = phase.workPackages.filter(
      (obj) => obj.id !== itemToDelete.id
    );
    onPhaseChange({ ...phase, workPackages: newWorkPackages });
  }

  useEffect(() => {
    const sortedWorkPackages = [...(phase?.workPackages ?? [])].sort((a, b) => {
      const aHasDate = !!a.endDate;
      const bHasDate = !!b.endDate;

      if (!aHasDate && !bHasDate) return 0; // both missing → keep order
      if (!aHasDate) return 1; // a missing → goes after b
      if (!bHasDate) return -1; // b missing → goes after a

      return moment(a.endDate).valueOf() - moment(b.endDate).valueOf();
    });

    setWorkPackages(sortedWorkPackages);
  }, [phase?.workPackages]);

  if (!editmode && phase.workPackages && !phase.workPackages.length) return;
  return (
    <CardGrid className="px-4 py-4 shadow-lg">
      {workPackages
        .filter((wp) => allowedStatuses?.includes(wp.status))
        .map((workPackage) => (
          <ProjectWorkPackage
            project={project}
            key={workPackage.id}
            workPackage={workPackage}
            onChange={handleChange}
            onDelete={handleDelete}
            editmode={editmode}
            onEdit={setEdit}
          />
        ))}
      {editmode && <ProjectAddElementButton onClick={() => setOpen(true)} />}
      <WorkPackageForm
        phaseId={phase.id}
        open={open || edit}
        onClose={() => {
          setEdit(null);
          setOpen(false);
        }}
        onChange={handleChange}
        startDataCollection={edit}
        projectId={project?.id}
      />
    </CardGrid>
  );
};

export default ProjectWorkPackageStack;
